// src/theme/typography.js
const typography = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  // Define responsive font sizes
  h1: {
    fontSize: "2.5rem", // Base size (will be scaled by responsiveFontSizes)
    "@media (min-width:600px)": {
      fontSize: "3rem",
    },
    "@media (min-width:960px)": {
      fontSize: "3.5rem",
    },
  },
  h2: {
    fontSize: "2rem",
    "@media (min-width:600px)": {
      fontSize: "2.5rem",
    },
    "@media (min-width:960px)": {
      fontSize: "3rem",
    },
  },
  // More natural line height for mobile reading
  body1: {
    lineHeight: 1.6,
  },
  body2: {
    lineHeight: 1.6,
  },
};

export default typography;
